// extracted by mini-css-extract-plugin
module.exports = {"highlighted":"LookupMenu_highlighted__2Apsa","liDetail":"LookupMenu_liDetail__1k3xC"};